module.exports = require('./helpers/bundle-url').getBundleURL('enTGv') + "logo-dark.eefe0b7f.svg";